import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import debounce from "lodash/throttle";
import { breakpoints, getDataAttributes, filterArrayByWhitelist, addClass, removeClass } from "../utils/helpers";
import { EventHandler } from "../utils/events";
import { bpEvents, bpList } from "../utils/breakpoints";
import { EfNav } from "../ef-nav/ef-nav";
import { Data } from "../utils/data";
import { defaultConfig, typeConfig, selectors, classNames, DATA_KEY } from "./ef-header.constants";
var hasHeader = false;
export var EfHeader = /*#__PURE__*/function () {
  function EfHeader(el, config) {
    _classCallCheck(this, EfHeader);

    this._el = el;
    this._config = this._getConfig(el, config);
    this._events = EventHandler;
    this._nav = this._el.querySelector(selectors.NAV);
    this._navInstance = null;
    this._offset = this._getOffset(this._config);
    this._lastScroll = 0;
    this._breakpointHandle = this._breakpointHandler.bind(this);
    this._scrollHandle = debounce(this._scrollHandler, 75, {
      leading: true,
      trailing: true
    }).bind(this);
    this._offsetHandle = this._scrollOffsetHandler.bind(this);
    this._transitionHandle = this._transitionHandler.bind(this);

    this._init();

    Data.setData(el, DATA_KEY, this);
  }

  _createClass(EfHeader, [{
    key: "destroy",
    value: function destroy() {
      var _this$_el$classList;

      if (this._navInstance) this._navInstance.destroy();
      EventHandler.off(document, bpEvents.UPDATED, this._breakpointHandler);

      this._events.off(window, "scroll", this._scrollHandle);

      this._events.off(this._el, "transitionend", this._transitionHandle);

      this._events.off(this._el, "transitioncancel", this._transitionHandle);

      (_this$_el$classList = this._el.classList).remove.apply(_this$_el$classList, _toConsumableArray(Object.values(classNames)));
    }
  }, {
    key: "_init",
    value: function _init() {
      this._breakpointHandle(breakpoints.current);

      EventHandler.on(document, bpEvents.UPDATED, this._breakpointHandle);
    }
  }, {
    key: "_breakpointHandler",
    value: function _breakpointHandler(bp) {
      if (typeof bp === "object") bp = bp.detail;

      if (bp === "s") {
        this._setup();
      } else {
        this.destroy();
      }
    }
  }, {
    key: "_setup",
    value: function _setup() {
      if (this._nav) this._navInstance = new EfNav(this._nav);

      this._events.on(this._nav, ".ef.nav.shown", this._offsetHandle);

      this._events.on(this._el, "transitionend", this._transitionHandle);

      this._events.on(this._el, "transitioncancel", this._transitionHandle);

      if (!this._config.sticky) return;

      this._events.on(window, "scroll", this._scrollHandle);
    }
  }, {
    key: "_scrollOffsetHandler",
    value: function _scrollOffsetHandler() {
      if (window.pageYOffset > this._config.dims.elHeight) return;

      if (window.pageYOffset < this._config.dims.stickyOffset) {
        window.scroll({
          top: 0,
          behavior: "smooth"
        });
        removeClass(this._el, classNames.OFFSET);
      } else {
        window.scroll({
          top: this._config.dims.stickyOffset,
          behavior: "smooth"
        });
        addClass(this._el, classNames.OFFSET);
      }
    }
  }, {
    key: "_transitionHandler",
    value: function _transitionHandler(e) {
      if (e.target.classList.contains(classNames.HIDE)) {
        removeClass(this._el, classNames.HIDE);
        removeClass(this._el, classNames.FIXED);
      }
    }
  }, {
    key: "_scrollHandler",
    value: function _scrollHandler() {
      var _this = this;

      var isShown = this._el.classList.contains(classNames.SHOW);

      var scrollUp = window.pageYOffset < this._lastScroll;
      var scrollDown = window.pageYOffset > this._lastScroll;
      var pastOffset = window.pageYOffset >= this._offset;
      var atStickyOffset = window.pageYOffset <= this._config.dims.stickyOffset;
      var pastHeaderEl = window.pageYOffset > Math.max(this._config.dims.elHeight, this._offset);

      var show = function show() {
        addClass(_this._el, classNames.SHOW);
        removeClass(_this._el, classNames.HIDE);
      };

      var hide = function hide() {
        addClass(_this._el, classNames.HIDE);
        removeClass(_this._el, classNames.SHOW);
      };

      if (pastHeaderEl) {
        addClass(this._el, classNames.FIXED);
      }

      if (atStickyOffset) {
        removeClass(this._el, classNames.FIXED); // ensure classes get cleaned up

        setTimeout(function () {
          removeClass(_this._el, classNames.HIDE);
          removeClass(_this._el, classNames.SHOW);
        }, 0);
      }

      if (scrollDown && isShown || !pastOffset && isShown) hide();
      if (scrollUp && pastOffset && !isShown) show();
      this._lastScroll = window.pageYOffset;
    }
  }, {
    key: "_getOffset",
    value: function _getOffset(config) {
      var triggerEl = document.querySelector(config.trigger);
      var offset = triggerEl && triggerEl.getBoundingClientRect().bottom + window.pageYOffset || 0;
      return Math.max(offset, config.dims.stickyOffset);
    }
  }, {
    key: "_getConfig",
    value: function _getConfig(el, config) {
      var _config = _objectSpread(_objectSpread(_objectSpread({}, defaultConfig), typeof config === "object" && config ? config : {}), getDataAttributes(el));

      _config.breakpoints = filterArrayByWhitelist(_config.breakpoints, bpList);
      _config.dims = typeConfig[_config.type];
      return _config;
    }
  }, {
    key: "toggle",
    value: function toggle() {
      if (!this._navInstance) return;

      this._navInstance.toggle();
    }
  }, {
    key: "show",
    value: function show() {
      if (!this._navInstance) return;

      this._navInstance.show();
    }
  }, {
    key: "hide",
    value: function hide() {
      if (!this._navInstance) return;

      this._navInstance.hide();
    }
  }], [{
    key: "activate",
    value: function activate(element, config) {
      var data = Data.getData(element, DATA_KEY);

      if (!data && !hasHeader) {
        data = new EfHeader(element, config);
        hasHeader = true;
      } else if (hasHeader) {
        // eslint-disable-next-line no-console
        console.warn("EfHeader: only one header may be initialised per page. Skipping");
      }

      return data;
    }
  }]);

  return EfHeader;
}();